var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-service-container"},_vm._l((_vm.items),function(modal,i){return _c('w-modal',{key:modal.uid,attrs:{"value":true,"full-height":""}},[_c('app-modal-item',{attrs:{"modal":modal},on:{"close":function($event){return _vm.closeModal(i)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }